module.exports = __webpack_public_path__ + "img/products-4.eaff3b53.jpg";